// extracted by mini-css-extract-plugin
export default {"CalendarIcon":"DatePicker_CalendarIcon__0Uybz","FormControl":"DatePicker_FormControl__Ksxeu","Horizonal":"DatePicker_Horizonal__4bHXq","Field":"DatePicker_Field__+kzWK"};